import { Dimensions, View } from 'react-native'

import styled from 'styled-components/native'

export const AppContainer = styled(View)<{
  web: boolean
  backgroundcolor: string
  isMobile: boolean
}>`
  border-radius: 5px;
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  ${({ web }) => !web && `
    height: ${Dimensions.get('screen').height}px;
    width: ${Dimensions.get('screen').width}px;
    justify-content: center;
    align-content: center;
  `}
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.4);
  elevation: 1;
  max-height: ${({ isMobile }) => (isMobile ? 'none' : '680px')};
  height: 100%;
 `
